/*
 * 活动
 * @Author: Lzyoung
 * @Date: 2019-03-15 10:38:13
 * @Last Modified by: Lzyoung
 * @Last Modified time: 2019-03-19 10:12:44
 */

export default [{
  path: '/events/coffee/questions',
  component: () => import('../components/delicacy/events/coffee/questions.vue'),
  meta: {
    title: "调查问卷"
  }
}, {
  path: '/events/coffee/submitted',
  component: () => import('../components/delicacy/events/coffee/submitted.vue'),
  meta: {
    title: "调查问卷"
  }
}]
